import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import { apiPostPublic, apiPostAuth} from "../utils/api";
import "../App.css";

const LoginPage = () => {
  const [user_name, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    
    const checkLogin = async () => {
      try {
        const response = await apiPostAuth("is_logged_in.php");
        if (response.status === 'success') {
          window.location.href = "/dashboard";
        } 
      } catch (error) {
        
      }
    };

    checkLogin();
    
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Make API call to register.php
      const response = await apiPostPublic("login.php", {
        user_name: user_name,
        password: password,
      });

    console.log(response)
    
      if (response.result === 1) {
        // Redirect user to dashboard page
        window.location.href = "/dashboard";
      } else {
        alert(response.message || "Gagal Login. Coba lagi nanti.");
      }
    } catch (error) {
      alert("Gagal Login. Coba lagi nanti.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <form onSubmit={handleLogin} className="form-container">
          <input
            type="text"
            placeholder="Username"
            className="input-field"
            value={user_name}
            onChange={(e) => setUserName(e.target.value)}
            required
          />
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          <button type="submit" className="primary-button">Login</button>
        </form>
        <div className="copyright">© MoriDapin.id 2026</div>
      </div>
    </div>
  );
};

export default LoginPage;
